import { Button, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../../../utils/formUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { creatNewGroup, updateGroupDetails } from '../../../../utils/PropertyAPIUtils';
import { fetchAllProperties } from '../../propertySlice';
import './Group-Create.scss';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const GroupCreate = (props) => {
  const { toggleDrawer, group, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    code: {
      value: '',
      fieldName: 'Group Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
    },
    name: {
      value: '',
      fieldName: 'Group Name',
      errors: {},
      validations: ['required'],
    },
    customSenderEmail: {
      value: '',
      fieldName: 'Group Email Id',
      errors: {},
      validations: ['required', 'validEmail'],
    },
    firebaseToken: {
      value: '',
      fieldName: 'Digital Key',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: [],
    },
  });
  const [isDisabled, disableSubmit] = useState(true);

  useEffect(() => {
    if (group) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = group[field];
      }
      setFormData(currFields);
    }
  }, [group]);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    e.preventDefault();
    if (validate()) {
      try {
        dispatch(stepUpLoaderCount());
        toggleDrawer('', false, '');
        let payload = {};
        for (let field in formData) {
          payload[field] = formData[field].value;
        }
        if (group) {
          await updateGroupDetails(group.id, payload, language);
          notificationManager('success', 'Group updated successfully');
        } else {
          await creatNewGroup(payload, language);
          notificationManager('success', 'Group created successfully');
        }
        dispatch(fetchAllProperties());
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          group
            ? notificationManager('danger', 'Group updation failed')
            : notificationManager('danger', 'Group creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  useEffect(() => {
    const isValid = formDataValidate(formData, false);
    disableSubmit(!isValid);
  }, [formData]);

  return (
    <form onSubmit={handleSubmit} className='group-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>{group ? 'Edit Group' : 'Add Group'}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          <h4 className='tab-title'>Group Details</h4>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.code}
                handleInputChange={(e) => {
                  setFormData({ code: e });
                }}
                multiline={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.customSenderEmail}
                handleInputChange={(e) => {
                  setFormData({ customSenderEmail: e });
                }}
                multiline={true}
              />
            </div>
            <div className='col-md-6 mt-3 mb-2'>
              <Tooltip title='This Email Id will be used to send invites' placement='right'>
                <InfoIcon style={{ fontSize: '15px' }} className='mt-2' />
              </Tooltip>
            </div>
          </div>
          <div className='col-md-6 mb-3'>
            <CustomTextField
              item={formData.firebaseToken}
              handleInputChange={(e) => {
                setFormData({ firebaseToken: e });
              }}
              multiline={true}
            />
          </div>
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <CustomTextField
                item={formData.description}
                handleInputChange={(e) => {
                  setFormData({ description: e });
                }}
                multiline={true}
              />
            </div>
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              type='submit'
              color='primary'
              className='me-3'
              size='large'
              disabled={isDisabled}
            >
              {group ? 'Update' : 'Add'}
            </Button>
            <Button
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default GroupCreate;
